import { PenLine, CheckSquare, Receipt, BarChart2, FolderOpen, Lock } from "lucide-react";
import MenuGrid from "./MenuGrid";

type ComptaMainItem = {
  id: string;
  icon: React.ComponentType<{ size?: number; strokeWidth?: number; className?: string }>;
  label: string;
  path: string;
};

/** Entrées de premier niveau pour fil d’Ariane / chemins principaux (Layout). */
export const comptaMainItems: ComptaMainItem[] = [
  { id: "saisie", icon: PenLine, label: "Saisie", path: "/compta/saisie" },
  { id: "revision", icon: CheckSquare, label: "Révision", path: "/compta/revision/balance" },
  { id: "fiscalite", icon: Receipt, label: "Fiscalité", path: "/compta/fiscalite" },
  { id: "etats-financiers", icon: BarChart2, label: "États financiers", path: "/compta/etats-financiers" },
  { id: "cloture-exercice", icon: Lock, label: "Clôture", path: "/compta/cloture-exercice" },
  { id: "dossier-client", icon: FolderOpen, label: "Dossier client", path: "/compta/dossier-client/ged" },
];

export interface ComptaMenuProps {
  sidebarCollapsed: boolean;
}

export default function ComptaMenu({ sidebarCollapsed }: ComptaMenuProps) {
  return <MenuGrid sidebarCollapsed={sidebarCollapsed} />;
}
